import * as React from "react";
import type { SVGProps } from "react";
const SvgSecureFilePermissions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M0 5.807A4.819 4.819 0 0 1 4.819.988H21.91a3.919 3.919 0 0 1 3.919 3.92c0 1.208.98 2.188 2.19 2.188h31.162A4.819 4.819 0 0 1 64 11.915V47.32a4.819 4.819 0 0 1-4.819 4.819H4.82A4.819 4.819 0 0 1 0 47.32V5.807Zm4.819-3.089a3.089 3.089 0 0 0-3.09 3.089V47.32a3.089 3.089 0 0 0 3.09 3.09H59.18a3.089 3.089 0 0 0 3.09-3.09V11.915a3.089 3.089 0 0 0-3.09-3.089H28.02A3.919 3.919 0 0 1 24.1 4.907c0-1.209-.98-2.189-2.19-2.189H4.82Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="m44.4 26.564 13.464 6.302s1.794 12.306-2.99 20.71c0 0-2.674 5.721-10.444 8.57h-.15c-7.77-2.852-10.443-8.57-10.443-8.57-4.784-8.404-2.99-20.71-2.99-20.71l13.464-6.302h.089Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M43.944 25.78a.865.865 0 0 1 .367-.081h.088c.127 0 .252.028.367.081l13.464 6.302c.264.124.447.371.49.659l-.857.125.856-.125v.004l.002.008.004.03.015.112a39.67 39.67 0 0 1 .191 1.963c.096 1.308.172 3.141.096 5.243-.151 4.172-.905 9.501-3.387 13.877a9.9 9.9 0 0 1-.137.263c-.097.18-.242.431-.44.74a17.694 17.694 0 0 1-1.86 2.397c-1.717 1.87-4.44 4.1-8.475 5.58a.865.865 0 0 1-.298.053h-.15a.865.865 0 0 1-.298-.053c-4.035-1.48-6.758-3.711-8.475-5.581a17.696 17.696 0 0 1-1.86-2.396 12.25 12.25 0 0 1-.551-.95 5.939 5.939 0 0 1-.026-.053c-2.482-4.376-3.236-9.705-3.387-13.877a48.82 48.82 0 0 1 .096-5.244 39.634 39.634 0 0 1 .191-1.962l.015-.112.004-.03.001-.008v-.003l.857.124-.856-.125a.865.865 0 0 1 .489-.659l13.464-6.302Zm-10.12 6.647s-2.183 1.06-2.186 1.08c-.038.343-.089.846-.134 1.476-.092 1.26-.165 3.03-.092 5.055.148 4.074.886 9.087 3.176 13.11l.03.06.001.001.003.006a3.334 3.334 0 0 0 .104.198c.079.146.203.363.378.635a15.96 15.96 0 0 0 1.678 2.159c1.53 1.668 3.962 3.674 7.573 5.044 3.612-1.368 6.042-3.375 7.574-5.043a15.964 15.964 0 0 0 1.677-2.16 10.551 10.551 0 0 0 .464-.796l.052-.104-20.299-20.72Zm20.298 20.721c2.29-4.023 3.029-9.036 3.176-13.11.073-2.025 0-3.794-.092-5.055a37.744 37.744 0 0 0-.141-1.536l-12.71-5.95-10.532 4.93"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M41.713 37.313a.183.183 0 0 0-.183.183v4.487a.865.865 0 1 1-1.73 0v-4.487c0-1.056.857-1.913 1.913-1.913h5.284c1.057 0 1.913.857 1.913 1.913v4.487a.865.865 0 1 1-1.73 0v-4.487a.183.183 0 0 0-.183-.183h-5.284Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M36.571 43.263c0-1.057.857-1.913 1.913-1.913h11.742c1.056 0 1.913.856 1.913 1.913v7.129a1.913 1.913 0 0 1-1.913 1.913H38.484a1.913 1.913 0 0 1-1.913-1.913v-7.13Zm1.913-.184a.183.183 0 0 0-.183.184v7.129c0 .1.082.183.183.183h11.742a.183.183 0 0 0 .183-.183v-7.13a.183.183 0 0 0-.183-.183H38.484Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSecureFilePermissions;
